module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-6.4525c5b0.png";